import React from "react";
import axios from "axios";

function TastoRiprovaRiga({
  token,
  aggiorna,
  tastoRefreshAspetto,
  apiUrl,
  datiRiga,
}) {
  const riprova = async function () {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }

    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    await axios.patch(
      apiUrl + "/prodotti/ps/retryDashboardRow",
      datiRiga,
      config,
    );
    aggiorna();
  };

  return (
    <div className="pointer dim w-100 tc" onClick={riprova}>
      {tastoRefreshAspetto}
    </div>
  );
}

export default TastoRiprovaRiga;
